export const ServiceDetailsTableData = [
  {
    product: "单链AAV",
    name:'高纯 ssAAV 病毒定制包装（ 常规产量血清型）',
    number:'5E+11 VGS',
    time:'12~18',
    directory:'3100',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格包含对照</p>
    </div>`,
  },
  {
    product: "单链AAV",
    name:'高纯 ssAAV 病毒定制包装（ 常规产量血清型）',
    number:'1E+12 VGS',
    time:'12~18',
    directory:'4900',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格包含对照</p>
    </div>`,
  },
  {
    product: "单链AAV",
    name:'高纯 ssAAV 病毒定制包装（ 常规产量血清型）',
    number:'2E+12 VGS',
    time:'12~18',
    directory:'6400',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格包含对照</p>
    </div>`,
  },
  {
    product: "单链AAV",
    name:'高纯 ssAAV 病毒定制包装（ 常规产量血清型）',
    number:'5E+12 VGS',
    time:'12~18',
    directory:'8200',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格包含对照</p>
    </div>`,
  },
  {
    product: "单链AAV",
    name:'高纯 ssAAV 病毒定制包装（ 常规产量血清型）',
    number:'1E+13  VGS',
    time:'12~18',
    directory:'13000',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格包含对照</p>
    </div>`,
  },
  {
    product: "单链AAV",
    name:'高纯 ssAAV 病毒定制包装（ 常规产量血清型）',
    number:'2E+13 VGS',
    time:'12~18',
    directory:'15800',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格不含对照</p>
    </div>`,
  },
  {
    product: "单链AAV",
    name:'高纯 ssAAV 病毒定制包装（ 常规产量血清型）',
    number:'5E+13 VG',
    time:'12~18',
    directory:'27800',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格不含对照</p>
    </div>`,
  },
  {
    product: "单链AAV",
    name:'高纯 ssAAV 病毒定制包装（ 常规产量血清型）',
    number:'1E+14 VGS',
    time:'12~18',
    directory:'需评估',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格不含对照</p>
    </div>`,
  },
  //---
  {
    product: "单链AAV",
    name:'高纯 ssAAV 病毒定制包装（ 超低产量血清型）',
    number:'2E+12 VGS',
    time:'12~18',
    directory:'10900',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格不含对照</p>
    </div>`,
  },
  {
    product: "单链AAV",
    name:'高纯 ssAAV 病毒定制包装（ 超低产量血清型）',
    number:'5E+12 VGS',
    time:'12~18',
    directory:'12500',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格不含对照</p>
    </div>`,
  },
  {
    product: "单链AAV",
    name:'高纯 ssAAV 病毒定制包装（ 超低产量血清型）',
    number:'1E+13 VGS',
    time:'12~18',
    directory:'19200',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格不含对照</p>
    </div>`,
  },
  {
    product: "单链AAV",
    name:'高纯 ssAAV 病毒定制包装（ 超低产量血清型）',
    number:'2E+13 VGS',
    time:'12~18',
    directory:'31700',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格不含对照</p>
    </div>`,
  },
  {
    product: "单链AAV",
    name:'高纯 ssAAV 病毒定制包装（ 超低产量血清型）',
    number:'5E+13 VGS',
    time:'12~18',
    directory:'53400',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格不含对照</p>
    </div>`,
  },
  {
    product: "单链AAV",
    name:'高纯 ssAAV 病毒定制包装（ 超低产量血清型）',
    number:'1E+14 VGS',
    time:'12~18',
    directory:'需评估',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格不含对照</p>
    </div>`,
  },
  //---双链AAV 高纯 scAAV 病毒定制包装
  {
    product: "双链AAV",
    name:'高纯 scAAV 病毒定制包装',
    number:'5E+11 VGS',
    time:'12~18',
    directory:'4250',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格包含对照</p>
    </div>`,
  },
  {
    product: "双链AAV",
    name:'高纯 scAAV 病毒定制包装',
    number:'1E+12 VGS',
    time:'12~18',
    directory:'6480',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格包含对照</p>
    </div>`,
  },
  {
    product: "双链AAV",
    name:'高纯 scAAV 病毒定制包装',
    number:'2E+12 VGS',
    time:'12~18',
    directory:'9450',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格包含对照</p>
    </div>`,
  },
  {
    product: "双链AAV",
    name:'高纯 scAAV 病毒定制包装',
    number:'5E+12 VGS',
    time:'12~18',
    directory:'14150',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格包含对照</p>
    </div>`,
  },
  {
    product: "双链AAV",
    name:'高纯 scAAV 病毒定制包装',
    number:'1E+13 VGS',
    time:'12~18',
    directory:'24900',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格包含对照</p>
    </div>`,
  },
  //---
  {
    product: "双链AAV",
    name:'高纯 scAAV 病毒定制包装',
    number:'2E+13 VGS',
    time:'12~18',
    directory:'26700',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格不含对照</p>
    </div>`,
  },
  {
    product: "双链AAV",
    name:'高纯 scAAV 病毒定制包装',
    number:'5E+13 VGS',
    time:'12~18',
    directory:'53400',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格不含对照</p>
    </div>`,
  },
  {
    product: "双链AAV",
    name:'高纯 scAAV 病毒定制包装',
    number:'1E+14 VGS',
    time:'12~18',
    directory:'需评估',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格不含对照</p>
    </div>`,
  },
  {
    product: "双链AAV",
    name:'高纯 scAAV 病毒定制包装',
    number:'2E+14 VGS',
    time:'12~18',
    directory:'需评估',
    remark: `<div style="text-align:left;">
      <p>1.不包含质粒构建费用和周期</p>
      <p>2.价格不含对照</p>
    </div>`,
  },
]

export const serotypeTableData = [
  {
    number: 1,
    type: "rAAV2/1",
    desc: "<span style='color:#fe2c23'>神经系统（高滴度顺向跨突触）</span>，肌肉，骨骼肌，心肌，平滑肌，肺，视网膜，胰腺，肝脏"
  },
  {
    number: 2,
    type: "rAAV2/2",
    desc: "<span style='color:#fe2c23'>视网膜</span>、神经系统，<span style='color:#fe2c23'>肌肉</span>，肝脏，血管平滑肌，肾脏"
  },
  {
    number: 3,
    type: "rAAV2/3",
    desc: "肌肉，<span style='color:#fe2c23'>肝脏</span>，肺，眼"
  },
  {
    number: 4,
    type: "rAAV2/4",
    desc: "神经系统，肌肉，眼，肺，肾脏，心脏"
  },
  {
    number: 5,
    type: "rAAV2/5",
    desc: "神经系统，肺，<span style='color:#fe2c23'>视网膜</span>，肝脏，滑膜关节，上皮细胞"
  },
  {
    number: 6,
    type: "rAAV2/6",
    desc: "神经系统，肺，肌肉，心脏，脂肪"
  },
  {
    number: 7,
    type: "rAAV2/7",
    desc: "肌肉，肝脏，眼"
  },
  {
    number: 8,
    type: "rAAV2/8",
    desc: "神经系统，<span style='color:#fe2c23'>肝脏</span>，肌肉，脂肪组织，胰腺，视网膜"
  },
  {
    number: 9,
    type: "rAAV2/9",
    desc: "<span style='color:#fe2c23'>神经系统</span>，心肌，肺，视网膜，皮肤，睾丸，肾脏，胰腺"
  },
  {
    number: 10,
    type: "rAAV2/10",
    desc: "灵长类心脏"
  },
  {
    number: 11,
    type: "rAAV2/11",
    desc: ""
  },
  {
    number: 12,
    type: "rAAV2/12",
    desc: ""
  },
  {
    number: 13,
    type: "AAV-DJ",
    desc: "视网膜，肺，肾脏，心脏，肝脏，脾脏，<span style='color:#fe2c23'>体外感染细胞</span>"
  },
  {
    number: 14,
    type: "AAV-Rh10",
    desc: "肝脏，血液，心脏，平滑肌，肺，胰腺，<span style='color:#fe2c23'>神经</span>，视网膜，肾脏，体外感染细胞"
  },
  {
    number: 15,
    type: "rAAV2-retro",
    desc: "<span style='color:#fe2c23'>神经系统（逆向非跨突触）</span>"
  },
  {
    number: 16,
    type: "AAV-PHP.eB",
    desc: "<span style='color:#fe2c23'>中枢神经系统（跨血脑屏障）</span>"
  },
  {
    number: 17,
    type: "AAV-LUNG",
    desc: "<span style='color:#fe2c23'>肺</span>，肝脏，肾脏"
  },

  {
    number: 18,
    type: "AAV.CAP-B10",
    desc: "<span style='color:#fe2c23'>神经（灵长类动物）</span>"
  },
  {
    number: 19,
    type: "AAV9-(A587G+Q601A)+RGDLRVS",
    desc: "<span style='color:#fe2c23'>内皮细胞</span>"
  },

  {
    number: 20,
    type: "AAV8（Y447F+Y733F）",
    desc: "<span style='color:#fe2c23'>胰腺</span>"
  },
  {
    number: 21,
    type: "AAV2. 4YF",
    desc: "视网膜"
  },
  {
    number: 22,
    type: "AAV-K912",
    desc: "脑，心脏，肺，眼"
  },
  {
    number: 23,
    type: "AAV-BI30",
    desc: "中枢神经系统内皮细胞"
  },
  {
    number: 24,
    type: "AAV2.7m8",
    desc: "视网膜"
  },
  {
    number: 25,
    type: "AAV2.NN",
    desc: "视网膜"
  },
  {
    number: 26,
    type: "AAV2.GL",
    desc: "视网膜"
  },
  {
    number: 27,
    type: "MyoAAV 1A",
    desc: "肌肉，心脏"
  },
  {
    number: 28,
    type: "AAV-ie-K558R",
    desc: "耳蜗"
  },
  {
    number: 29,
    type: "AAV-CAP-Mac",
    desc: "神经（灵长类）"
  },
  {
    number: 30,
    type: "AAV- Anc80L65",
    desc: "耳蜗"
  },
  {
    number: 31,
    type: "AAV-Olig001",
    desc: "神经系统"
  },
  {
    number: 32,
    type: "AAV-PHP.B",
    desc: "神经系统"
  },
  {
    number: 33,
    type: "AAV-PHP.S",
    desc: "神经系统"
  },
  {
    number: 34,
    type: "AAV 8BP2",
    desc: "眼"
  },
  {
    number: 35,
    type: "AAV-ShH10Y",
    desc: "视网膜Müller细胞"
  },
  {
    number: 36,
    type: "AAV-SCH9",
    desc: "SVZ区神经干细胞"
  },
  {
    number: 37,
    type: "AAVCPP.16",
    desc: "神经（灵长类）"
  },
  {
    number: 38,
    type: "AAVCPP.20",
    desc: "神经（灵长类）"
  },
  {
    number: 39,
    type: "AAV.Cap-B10",
    desc: "神经"
  },
]

export const customizedPackagingTableData = [
  {
    type: "神经",
    name: "syn",
    desc: "神经元特异性启动子"
  },
  {
    type: "神经",
    name: "NSE",
    desc: "神经元特异性启动子"
  },
  {
    type: "神经",
    name: "TH",
    desc: "儿茶酚胺能神经元（DA、NE、E)"
  },
  {
    type: "神经",
    name: "Somatostat(SST)",
    desc: "γ﹣氨基丁酸能抑制性神经元SST亚型特异性启动子"
  },
  {
    type: "神经",
    name: "shortGFAP",
    desc: "星形胶质细胞（短启动子）"
  },
  {
    type: "神经",
    name: "GfaABCID",
    desc: "星形胶质细胞"
  },
  {
    type: "神经",
    name: "hVGAT",
    desc: "GABA能神经元／中间神经元特异性"
  },
  {
    type: "神经",
    name: "GAD67",
    desc: "GABA能中间神经元"
  },
  {
    type: "神经",
    name: "MBP",
    desc: "少突胶质细胞"
  },
  {
    type: "神经",
    name: "ALDHIL1",
    desc: "丘脑中星形胶质细胞特异性启动子"
  },
  {
    type: "神经",
    name: "mDLx",
    desc: "GABA能中间神经元"
  },
  {
    type: "神经",
    name: "fPV",
    desc: "PV＋中间神经元"
  },
  {
    type: "神经",
    name: "fNPY",
    desc: "NPY＋中间神经元"
  },
  {
    type: "神经",
    name: "FEV",
    desc: "五羟色胺能神经元"
  },
  {
    type: "神经",
    name: "Ibal/CX3CR1",
    desc: "小胶质细胞"
  },
  {
    type: "神经",
    name: "NG2/NGL2",
    desc: "少突胶质细胞前体细胞"
  },
  {
    type: "神经",
    name: "PRSx8",
    desc: "去甲肾上腺素能神经元"
  },
  {
    type: "神经",
    name: "ChAT",
    desc: "胆碱能神经元"
  },
  {
    type: "神经",
    name: "D1/D2",
    desc: "多巴胺D1/D2受体神经元"
  },
  {
    type: "神经",
    name: "HCRT",
    desc: "下丘脑食欲素神经元"
  },
  {
    type: "神经",
    name: "S1c6a3",
    desc: "多巴胺神经元特异性表达启动子"
  },
  {
    type: "神经",
    name: "fSST",
    desc: "SST＋中间神经元"
  },
  {
    type: "神经",
    name: "CNP",
    desc: "少突胶质细胞或施万细胞特异性表达启动子"
  },
  {
    type: "神经",
    name: "TUBA1A",
    desc: "早期神经元特异性启动子"
  },
  {
    type: "神经",
    name: "DAT",
    desc: "多巴胺能神经元"
  },
  {
    type: "神经",
    name: "L7pcp2",
    desc: "小脑蒲肯野细胞"
  },
  //--
  {
    type: "肝脏",
    name: "ALB",
    desc: "肝脏特异性启动子（肝实质细胞和前体细胞）"
  },
  {
    type: "肝脏",
    name: "TBG",
    desc: "肝脏特异性启动子（成熟的肝实质细胞）"
  },
  {
    type: "肝脏",
    name: "ApoEHCR-hAAT",
    desc: "肝脏特异性启动子"
  },
  //--
  {
    type: "心脏",
    name: "aMHC",
    desc: "心脏特异性启动子"
  },
  {
    type: "心脏",
    name: "nNkx2.5",
    desc: "心肌细胞早期特异性启动子"
  },
  {
    type: "心脏",
    name: "cTNT",
    desc: "心脏特异性启动子"
  },
  //
  {
    type: "胰腺",
    name: "Insulin receptor",
    desc: "胰腺β细胞特异性启动子"
  },
  {
    type: "B细胞",
    name: "CD19",
    desc: "B细胞特异性启动子"
  },
  {
    type: "血管",
    name: "SM22a",
    desc: "血管平滑肌特异性启动子"
  },
  {
    type: "血管",
    name: "CD68",
    desc: "单核巨噬细胞特异性启动子"
  },
  {
    type: "血管",
    name: "F4/80",
    desc: "巨噬细胞特异性启动子"
  },
  {
    type: "眼",
    name: "Rpe65",
    desc: "视网膜色素上皮细胞特异性启动子"
  },
  {
    type: "眼",
    name: "VMD2",
    desc: "视网膜色素上皮细胞特异性启动子"
  },
  {
    type: "肾脏",
    name: "NPHS2",
    desc: "肾脏足细胞特异性启动子"
  },
  {
    type: "肾脏",
    name: "Ksp-cadherin",
    desc: "肾小管上皮细胞特异性启动子"
  },
  {
    type: "成纤维细胞",
    name: "FAP",
    desc: "成纤维细胞启动子"
  },
  {
    type: "诱导型",
    name: "TRE",
    desc: "诱导型启动子"
  },
  {
    type: "诱导型",
    name: "TRE3G",
    desc: "诱导型启动子"
  },
  {
    type: "广谱型",
    name: "CBh/CMV/EF-1a/CAG/CB",
    desc: "常用广谱启动子"
  },
]


// WEBPACK FOOTER //
// ./src/views/Virus/contans.js